/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default () => ({
    usersConfig: {
        include: 'company,roles',
        sort: 'id',
        sortDirection: '',
        page: 1,
        filters: {},
        per_page: 15
    },
    users: null,
    usersFilters: null,
    citizensConfig: {
        page: 1,
        per_page: 15,
        search: '',
        role: ''
    },
    citizens: null,
    newCitizen: {
        name: null,
        email: null,
        phone: null,
        password: null,
        password_confirmation: null,
        role: 'technical_agent'
    },
    newUser: {
        name: null,
        job_title: null,
        email: null,
        phone: null,
        user_type : 0,
        locale: null,
        role: null
    },
    newWebhook: {
        name: null,
        url: null,
        signature_secret: null
    },
    company: null,
    companySettings: null,
    companyHeaderMail: null
})
